import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import PageBuilder from '../PageBuilder/PageBuilder';
import Navigation from '../Navigation/Navigation';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import { getLandingPageConfig } from '../../config/pages';

/**
 * LandingPage - Componente para landing pages dinámicas
 * Obtiene la configuración según el ID en la URL (local o desde el servidor)
 */
const LandingPage = () => {
  const { id } = useParams();
  const landingId = id || 'default';

  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getLandingPageConfig(landingId)
      .then(setConfig)
      .catch(() => setError('No encontramos esta landing page.'))
      .finally(() => setLoading(false));
  }, [landingId]);

  if (loading) return null;

  if (error) return (
    <div style={{ color: '#e0dad2', padding: '80px', textAlign: 'center', background: '#111' }}>
      <p>{error}</p>
    </div>
  );

  return (
    <>
      <Navigation />
      <main className="page-content">
        <PageBuilder sections={config.sections} />
      </main>
      <WhatsAppButton />
    </>
  );
};

export default LandingPage;
